import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./../api/request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { CommonService } from "../api";

@Injectable({
  providedIn: "root",
})
export class HospitalService {
  constructor(
    private request: Request,
    private http: HttpClient,
    private _commonService: CommonService,
  ) {
  }


  getHospitalsList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.x_a2z_apis.getHospitalsList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }

  saveHospitals(values): Observable<any> {
    let url = URLS.x_a2z_apis.createHospitals;

    url = _.replace(url, "{entity}", this._commonService.getEntity());

    return this.request.postApi(url, values);
  }

  editHospitals(id, values): Observable<any> {
    let url = URLS.x_a2z_apis.hospitalsUpdate;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteHospitals(data): Observable<any> {
    let url = URLS.x_a2z_apis.hospitalsDelete;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getHospitalsInfo(id): Observable<any> {
    let url = URLS.x_a2z_apis.hospitalFetch;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }


  getHospitalListAll(type?: string): Observable<any> {
    let url = URLS.x_a2z_apis.getHospitalListAll + '?type=' + type;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }


  getHospitalGroupsList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.x_a2z_apis.getHospitalGroupsList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }

  saveHospitalGroups(values): Observable<any> {
    let url = URLS.x_a2z_apis.createHospitalGroups;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.postApi(url, values);
  }

  editHospitalGroups(id, values): Observable<any> {
    let url = URLS.x_a2z_apis.hospitalGroupsUpdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteHospitalGroups(data): Observable<any> {
    let url = URLS.x_a2z_apis.hospitalGroupsDelete;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getHospitalGroupsInfo(id): Observable<any> {
    let url = URLS.x_a2z_apis.hospitalGroupFetch;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }

  getHospitalGroupsListAll(): Observable<any> {
    let url = URLS.x_a2z_apis.getHospitalGroupsListAll;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }




  getContractList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.x_a2z_apis.getContractList + '?from=' + event.fromdate + '&to=' + event.todate + '&limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction + '&type=' + event.type;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }

  saveContract(values): Observable<any> {
    let url = URLS.x_a2z_apis.createContract;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.postApi(url, values);
  }

  editContract(id, values): Observable<any> {
    let url = URLS.x_a2z_apis.ContractUpdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteContract(data): Observable<any> {
    let url = URLS.x_a2z_apis.ContractDelete;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getContractInfo(id): Observable<any> {
    let url = URLS.x_a2z_apis.ContractFetch;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }

  getContractListAll(): Observable<any> {
    let url = URLS.x_a2z_apis.getContractListAll;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }
}
